import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import './App.css';
import Users from './pages/users';
import LogsPage from './pages/logs';
import HomePage from './components/home';
import OrdersPage from './pages/orders';
import LoginPage from './pages/login';
import SyncPlansPage from './pages/sync-plans';
import SubscriptionsPage from './pages/subscriptions';
import WebhooksPage from './pages/webhooks';
import ShareAndEarnPage from './pages/shareandearn';
import ReferralPage from './pages/referral';
import PartnerProgramPage from './pages/partner-program';
import PreviewPartnerPage from './pages/preview-partner';
import PreviewOrganizationPage from './pages/preview-organization';
import PromoCodePage from './pages/promoCode';
import EsimPurchasesAdmin from './pages/esim';
import EsimPurchaseDetails from './pages/esimPurchase';
import GiftEsimsPage from './pages/giftEsims';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/users" element={<Users />} />
      <Route path="/dashboard/logs" element={<LogsPage />} />
      <Route path="/dashboard/orders" element={<OrdersPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard/sync-plans" element={<SyncPlansPage />} />
      <Route path="/dashboard/subscriptions" element={<SubscriptionsPage />} />
      <Route path="/dashboard/webhooks" element={<WebhooksPage />} />
      <Route path="/dashboard/shareandearn" element={<ShareAndEarnPage />} />
      <Route path="/dashboard/partner-program" element={<PartnerProgramPage />} />
      <Route path="/dashboard/shareandearn/referral/:id" element={<ReferralPage />} />
      <Route path="/dashboard/partner-program/preview-partner/:id" element={<PreviewPartnerPage />} />
      <Route path="/dashboard/partner-program/preview-organization/:id" element={<PreviewOrganizationPage />} />
      <Route path="/dashboard/promo-code" element={<PromoCodePage />} />
      <Route path="/dashboard/esim-purchases" element={<EsimPurchasesAdmin />} />
      <Route path="/dashboard/esim-purchases/:id" element={<EsimPurchaseDetails />} />
      <Route path="/dashboard/gift-esims" element={<GiftEsimsPage />} />
    </Routes>
  );
}

export default App;
